import * as authSelectors from "@rentiohq/shared-frontend/dist/redux/auth/auth.selectors";
import { IUser } from "@rentiohq/shared-frontend/dist/types/auth.types";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { IRootState } from "../redux/reducers";

const withKycRequired = (Component: any) => {
  const WithKycRequired = (props: any) => {
    const user = useSelector((state: IRootState) =>
      authSelectors.getUser(state),
    );

    // Helpers
    const userIsCompleted = ({ personalContact }: IUser) => {
      const { dateOfBirth, nationality, countryId, street, number, city, zip } =
        personalContact;
      return (
        dateOfBirth &&
        nationality &&
        countryId &&
        street &&
        number &&
        city &&
        zip
      );
    };

    // Render
    const renderRedirect = (pathname: string) => (
      <Navigate
        to={{
          pathname,
        }}
        state={{
          referrer: `${window.location.pathname}${window.location.search}`,
        }}
      />
    );

    if (user && !userIsCompleted(user)) {
      return renderRedirect("/kyc");
    }

    return <Component {...props} />;
  };

  return WithKycRequired;
};

// eslint-disable-next-line import/no-default-export
export default withKycRequired;
